// MyWalletToPocket.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
// import MainLayout from '../../layouts/MainLayout';
import './MyWallet.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faCheck, faClipboardCheck, faFileAlt } from '@fortawesome/free-solid-svg-icons';


const MyWalletToPocket = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const [userId, setUserId] = useState(authState.user._id);
  const [payerCode, setPayerCode] = useState(authState.user.think5whyscode);

  const [payerName, setPayerName] = useState(authState.user.name);
  const [payeeId, setPayeeId] = useState('');
  const [payeeCode, setPayeeCode] = useState('');
  const [payeeName, setPayeeName] = useState('');
  const [remarks, setRemarks] = useState('AI Counselling Prepaid Pocket');
  const [amount, setAmount] =  useState(0);
  const [paymentClicked, setPaymentClicked] = useState(false);
  const [modePayment, setModePayment] = useState('Online');
  const [transactionId, setTransactionId] = useState('123456789');
  const [transactionDate, setTransactionDate] = useState(new Date());
  const [transactionStatus, setTransactionStatus] = useState('');
  const [paymentDetails, setPaymentDetails] = useState('');
  const [error, setError] = useState(null);
  const [walletBalanceAmount, setWalletBalanceAmount] = useState(0.00);
  const [walletBalancePoints, setWalletBalancePoints] = useState(0);
  const [walletLastUpdated, setWalletLastUpdated] = useState();
  const [walletLastUpdatedRemarks, setWalletLastUpdatedRemarks] = useState('');
  const [payeeCodeStatus, setPayeeCodeStatus] = useState(false);
  const [payeeCodeStatusMsg, setPayeeCodeStatusMsg] = useState('');
  const [payeeCodeButtonClicked, setPayeeCodeButtonClicked] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(false);
  
  const [doWalletTopup, setDoWalletTopup] = useState(false);

//WalletBalance
const fetchWalletBalance = useCallback(() => {
  const config = {
      url: "/walletbalance",
      method: "get",
      headers: { Authorization: authState.token }
  };

  fetchData(config, { showSuccessToast: false })
      .then(response => {
          // console.log("Wallet Balance Response:", response);
          if (response) {
              setWalletBalanceAmount(response.balanceAmount);
              setWalletBalancePoints(response.balancePoints);
              setWalletLastUpdated(response.lastTransactionDate);
              setWalletLastUpdatedRemarks(response.remarks);
          } else {
              console.error("Invalid response format: Wallet not found in response");
              setWalletBalanceAmount(0);
              setWalletBalancePoints(0);
              setWalletLastUpdated(null);
              setWalletLastUpdatedRemarks('');
          }
      })
      .catch(error => {
          console.error("Error fetching wallet master:", error);
          setWalletBalanceAmount(0);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchWalletBalance();
  }, [authState.isLoggedIn, fetchWalletBalance]);

  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    amount: "118.00",
    remarks: "AI Counselling Prepaid Pocket"
  });

  const handleChange = e => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )

  
  const payeeCodeValidationClicked = () => {
      // Validate Amount
      if (formData.amount <= 0 || !/^[0-9]+(\.[0-9]{1,2})?$/.test(formData.amount)) {
          setError("Error in Amount Input");
          return;
      }
      
      // Check Wallet Balance
      if (formData.amount > walletBalanceAmount) {
          setError("Your Wallet Balance has insufficient funds to make the transfer. Please recharge your Wallet.");
          setDoWalletTopup(true);
          return;
      }  

      if (formData.remarks=='') {
        setError("Transfer Remarks is required!!");
        return;
      }
};


const handleTransferButtonClick = () => {
    setPaymentClicked(true);
    saveWalletTransaction();
};

const saveWalletTransaction = async () => {
  const requestData = {
    payerName: payerName,
    payerId: userId,
    payeeId: payeeId,
    dateTransaction: new Date(),
    particulars: "Wallet Transfer to my ThinkAIInsight Pocket",
    amount: formData.amount,
    currency: "Credits",
    inOut: 2,  //Transfer (Out)
    points: 0,
    wallet: "User Wallet",
    remarks: formData.remarks,
    modePayment: '"Think5Whys Wallet Transfer"',
    transactionId: 'D' + Date.now(),
    transactionDate: Date.now(),
    transactionStatus: 'Success',
    paymentDetails: 'NA',
    isActive: 1,
    isDeleted: 0,
    dateCreated: new Date(),
    createdBy: userId,
  };
  // console.log('Wallet Transfer data to be saved:', requestData);
  try {
    const config = { 
      url: `/wallet/pockettransfer`, 
      method: "post", 
      data: requestData, 
      headers: { Authorization: authState.token } 
    };
    await fetchData(config);
    setPaymentStatus(true)
    // console.log("After Saving Data", fetchData)
    navigate(-1);
  } catch (error) {
    console.error('An error occurred while fetching data:', error);
  }
};

const handleCancel = () => {
  navigate(-1);
};

  return (
    <div>
      <div className="mx-auto p-6 bg-gray-900 text-white min-h-screen flex flex-col">
        <h2 className="text-lg lg:text-xl font-semibold mb-6 text-yellow-200 border-b border-blue-400 pb-2">Think5Whys Wallet to Think5Whys AI Pocket Transfer</h2>

        <div className="flex-grow bg-black p-6 rounded-lg shadow-lg">
            <div className="mb-6 text-center">
              <p className="text-lg font-medium">Your Wallet Balance: <span className="text-green-400">Credits {walletBalanceAmount.toFixed(2)}</span></p>
            </div>
            <div className="flex flex-col items-center">
              <input
                type="number"
                name="amount"
                id="amount"
                value={formData.amount}
                placeholder="Input Amount"
                onChange={handleChange}
                min="59"
                max="238"
                className="h-12 px-4 text-center border border-gray-300 rounded-md bg-gray-700 text-white"
              />
              {fieldError("Amount")}
            </div>

            <div className="flex flex-col items-center">
              <input
                type="text"
                name="remarks"
                id="remarks"
                value={formData.remarks}
                placeholder="Input Remarks"
                onChange={handleChange}
                style={{width: "100"}}
                className="mt-4 h-12 px-4 text-center border border-gray-300 rounded-md bg-gray-700 text-white"
              />
              {fieldError("Remarks")}
            </div>
          </div>

          { doWalletTopup && (
            <div className="mb-2 text-center flex flex-row">
              <button
                onClick={() => navigate("/wallet-topup")}
                className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
              >
                Wallet Topup 
              </button>
            </div>
            )}
            
          <div className="mb-2 text-center flex flex-row">
              <button
                onClick={handleTransferButtonClick}
                disabled={paymentClicked}
                className="bg-orange-500 text-white px-6 py-2 rounded-lg shadow-md hover:bg-orange-600 transition duration-300"
              >
                Confirm Transfer of Credits {parseFloat(formData.amount).toFixed(2)} to ThinkAIInsight Pocket
              </button>
              <button
                onClick={handleCancel}
                className="bg-blue-500 hover:bg-blue-600 text-white font-bold ml-4 py-2 px-4 rounded"
              >
                Cancel
              </button>
            </div>

            {paymentClicked && (
              <div className="text-center">
                {paymentStatus ? (
                  <p className="text-green-500">Transferred Credits {parseFloat(formData.amount).toFixed(2)} to {payeeName}'s Wallet</p>
                ) : (
                  <p className="text-red-500">Transfer of Credits {parseFloat(formData.amount).toFixed(2)} to {payeeName} Failed. Please Retry.</p>
                )}
              </div>
            )}
          </div>
          <footer className="sticky bg-black border-t border-blue-400 text-white py-2 px-4 mt-2">
              <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
                  <p className="text-xs sm:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
                  <div className="flex flex-row gap-2 sm:gap-6 text-xs sm:text-sm">
                  <Link to="/about-us" className="text-white hover:text-purple-200 transition">About</Link>
                  <Link to="/privacy-policy" className="text-white hover:text-purple-200 transition">Privacy Policy</Link>
                  <Link to="/terms-of-use" className="text-white hover:text-purple-200 transition">Terms of Use</Link>
                  <Link to="/contact-us" className="text-white hover:text-purple-200 transition">Contact</Link>
                  </div>
              </div>
          </footer>  
    </div>
  );
};

export default MyWalletToPocket;
